import { inject, Injectable } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PasConfirmationService } from '@porsche-aftersales/frontend-toolbox';
import { Observable } from 'rxjs';

import { RecourseCampaignComponent } from '../../content/recourse-campaign/recourse-campaign.component';

import { confirmNavbarTabChangeDialog } from './guard-functions';

@Injectable({
  providedIn: 'root',
})
export class RecourseCampaignGuard {
  private readonly translateService = inject(TranslateService);
  private readonly pasConfirmationService = inject(PasConfirmationService);

  public canDeactivate(target: RecourseCampaignComponent): boolean | Observable<boolean> | Promise<boolean> {
    return target?.aktionsRegressDetailsComponent?.formValueChanged
      ? confirmNavbarTabChangeDialog(this.translateService, this.pasConfirmationService)
      : true;
  }
}

export const recourseCampaignGuardCanDeactivate: CanDeactivateFn<RecourseCampaignComponent> = (
  target: RecourseCampaignComponent,
): boolean | Observable<boolean> | Promise<boolean> => inject(RecourseCampaignGuard).canDeactivate(target);
